import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import SectionTitle from '../common/SectionTitle';
import Reveal from '../common/Reveal';
import ServiceCard from '../services/ServiceCard';
import { SERVICES } from '../../data/services';

// Curated subset (multiple of 3) so the grid stays full — the rest live on /services.
const PREVIEW_SERVICES = SERVICES.filter((svc) => svc.category !== 'environment');

const ServicesPreview = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <Reveal>
          <SectionTitle
            title={t('home.services.title')}
            subtitle={t('home.services.subtitle')}
          />
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 mb-12">
          {PREVIEW_SERVICES.map((svc, i) => (
            <Reveal key={svc.id} delay={i * 80} className="h-full">
              <ServiceCard service={svc} />
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="text-center">
            <Link
              to="/services"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-primary-500 text-primary-600 dark:text-primary-400 rounded-xl font-semibold hover:bg-primary-500 hover:text-white transition-all duration-300"
            >
              {t('home.services.viewAll')}
              <svg className="w-4 h-4 rtl:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ServicesPreview;
